// PWA 周り: インストール導線・standalone 判定・ストレージ永続化・容量。
// iOS は beforeinstallprompt が来ないので「ホーム画面に追加」を手順で案内する。
import { t } from './i18n.js'

let deferredPrompt = null
// Android / デスクトップ Chrome 系はこのイベントでワンタップ設置できる。
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  deferredPrompt = e
})
window.addEventListener('appinstalled', () => {
  deferredPrompt = null
})

// ホーム画面 PWA として起動しているか。
export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  )
}

export function isIOS() {
  const ua = navigator.userAgent || ''
  return (
    /iphone|ipad|ipod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  )
}

export function canPromptInstall() {
  return !!deferredPrompt
}

// Chrome 系のネイティブ設置プロンプト。戻り値: 受け入れたか。
export async function promptInstall() {
  if (!deferredPrompt) return false
  deferredPrompt.prompt()
  const { outcome } = await deferredPrompt.userChoice
  deferredPrompt = null
  return outcome === 'accepted'
}

// ===== ストレージ永続化 =====
export async function isPersisted() {
  try {
    return navigator.storage?.persisted ? await navigator.storage.persisted() : false
  } catch {
    return false
  }
}
export async function requestPersist() {
  try {
    if (navigator.storage?.persist && !(await navigator.storage.persisted())) {
      return await navigator.storage.persist()
    }
    return await isPersisted()
  } catch {
    return false
  }
}

// 容量不足エラーを分かりやすい文言へ。
export function describeError(e) {
  const name = e?.name || ''
  if (name === 'QuotaExceededError' || /quota/i.test(e?.message || '')) {
    return t('err.storageFull')
  }
  return e?.message || String(e)
}
